import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Loading component for route-based code splitting
 * Provides a consistent loading experience across all lazy-loaded routes
 */
export const RouteLoading: React.FC = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="flex flex-col items-center space-y-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm text-muted-foreground animate-pulse">Loading...</p>
      </div>
    </div>
  );
};

/**
 * More specific loading component for authenticated pages with sidebar
 */
export const AuthenticatedRouteLoading: React.FC = () => {
  return (
    <div className="flex-1 flex flex-col bg-background min-w-0 w-full">
      <main className="flex-1 min-w-0 w-full bg-background p-6">
        <div className="max-w-7xl mx-auto">
          {/* Header skeleton */}
          <div className="mb-6 animate-pulse">
            <div className="h-8 bg-muted rounded w-1/4 mb-4"></div>
            <div className="h-4 bg-muted rounded w-1/2"></div>
          </div>

          {/* Content skeleton */}
          <div className="space-y-6 animate-pulse">
            <div className="h-32 bg-muted rounded"></div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="h-24 bg-muted rounded"></div>
              <div className="h-24 bg-muted rounded"></div>
            </div>
            <div className="h-48 bg-muted rounded"></div>
          </div>
        </div>
      </main>
    </div>
  );
};

/**
 * Loading component for public pages (login, signup, etc.)
 */
export const PublicRouteLoading: React.FC = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="w-full max-w-md p-6">
        <div className="animate-pulse space-y-6">
          {/* Logo skeleton */}
          <div className="flex justify-center">
            <div className="h-12 w-32 bg-muted rounded"></div>
          </div>

          {/* Form skeleton */}
          <div className="bg-card p-6 rounded-lg shadow-lg space-y-4">
            <div className="h-6 bg-muted rounded w-3/4"></div>
            <div className="space-y-3">
              <div className="h-10 bg-muted rounded"></div>
              <div className="h-10 bg-muted rounded"></div>
              <div className="h-10 bg-accent rounded"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
